// import Header from './Component/Header';
import Footer from './Component/Footer';
import MenuBar from './Component/MenuBar';
import PageBanner from './Component/PageBanner';
import Sidebar from './Component/Sidebar';
import WordofWisdomeCard from '../WordofWisdomeCard'


const WordsOfWisdom = () => {
    return (
        <>


            {/* <Header/> */}

            <MenuBar />
            <Sidebar />

            {/* <!-- Page Banner Section --> */}
            <PageBanner title="Words of Wisdom" />

            {/* <!--End Banner Section --> */}

            {/* <!--Sidebar Page Container--> */}
         <WordofWisdomeCard/>
            {/* <!-- End Sidebar Page Container --> */}




            <Footer />

        </>


    )


}

export default WordsOfWisdom;
